module.exports = __webpack_public_path__ + "NiKi-95a88720.png";